import React, { useMemo } from 'react';
import { GivelifyLabel, GivelifyLabelStyles } from '@givelify/givelify-ui';
import { GivelifyFormTextField } from '@givelify/ui';
import { useAdvancedTranslation } from '@givelify/utils';
import { useGasRouterContext } from 'router/GasRouterProvider';
import { CampusItem } from '../../../types';
import {
    Wrapper,
    AddressWrapper,
    TextWrapper,
    StyledLink,
    TextFieldWrapper,
} from './styles';

interface EditFormProps {
    item: CampusItem;
}

const EditForm: React.FCC<EditFormProps> = ({ item }) => {
    const { PATH } = useGasRouterContext();
    const { body1 } = GivelifyLabelStyles({});

    const { address, city, state, name, zip, phone } = item;

    const { scopedTranslate } = useAdvancedTranslation({
        TRANSLATION_KEY: 'pages.settings.campuses.list.listItem.editModal',
    });

    const copy = useMemo(
        () => ({
            campusDetails: scopedTranslate('campusDetails'),
            nicknameTitle: scopedTranslate('nicknameTitle'),
            nicknameDescription: scopedTranslate('nicknameDescription'),
            nicknameLabel: scopedTranslate('nicknameLabel'),
            nicknameHelper: scopedTranslate('nicknameHelper'),
            nicknameUniqueValidation: scopedTranslate(
                'nicknameUniqueValidation',
            ),
            nameTitle: scopedTranslate('nameTitle'),
            nameDescription: scopedTranslate('nameDescription'),
            linkDescription: scopedTranslate('linkDescription'),
            linkText: scopedTranslate('linkText'),
        }),
        [scopedTranslate],
    );

    return (
        <Wrapper>
            <GivelifyLabel
                marginBottom={24}
                text={copy.campusDetails}
                variant="heading3"
            />
            <GivelifyLabel
                marginBottom={16}
                text={copy.nicknameTitle}
                variant="heading5"
            />
            <GivelifyLabel
                marginBottom={16}
                text={copy.nicknameDescription}
                variant="body1"
            />
            <TextFieldWrapper>
                <GivelifyFormTextField
                    countLength
                    fullWidth
                    id="shortName"
                    label={copy.nicknameLabel}
                    leftHelperText={copy.nicknameHelper}
                    maxLength={50}
                    name="shortName"
                />
            </TextFieldWrapper>
            <GivelifyLabel
                marginBottom={16}
                text={copy.nameTitle}
                variant="heading5"
            />
            <GivelifyLabel
                marginBottom={16}
                text={copy.nameDescription}
                variant="body1"
            />
            <AddressWrapper id={`campus-address-wrapper`}>
                <GivelifyLabel
                    id="campus-name"
                    text={name}
                    variant="heading4"
                />
                <GivelifyLabel
                    id="campus-address"
                    text={address}
                    variant="heading4"
                />
                <GivelifyLabel
                    id="campus-city-state-zip"
                    text={`${city}, ${state} ${zip}`}
                    variant="heading4"
                />
                <GivelifyLabel
                    id="campus-phone"
                    text={phone}
                    variant="heading4"
                />
            </AddressWrapper>
            <TextWrapper className={body1}>
                {`${copy.linkDescription} `}
                <StyledLink
                    title={copy.linkText}
                    to={PATH.SETTINGS.APP_PROFILE('profile')}
                >
                    {copy.linkText}
                </StyledLink>
                {'.'}
            </TextWrapper>
        </Wrapper>
    );
};

export default EditForm;
